/**
 * Cue the icon rail when the focused main tab belongs to a mode the sidebar
 * is not showing. 3 inset-ring pulses (`rail-suggested-pulse`), then settle.
 * No auto-switch. Gallery: /?test=maater-ui#panel-collapse
 *
 * Slice E shipped Basecamp. Inbox / Chats use the same mismatch cue.
 */

export type SuggestedRailId = 'basecamp' | 'inbox' | 'chats'

export function isBasecampLimbTab(
  tab: { id?: string; type?: string } | null | undefined,
): boolean {
  if (!tab) return false
  const id = String(tab.id ?? '')
  const type = String(tab.type ?? '')
  if (id === 'basecamp' || id.startsWith('basecamp-')) return true
  if (type.startsWith('integration-basecamp') || type.startsWith('basecamp-')) return true
  return false
}

export function isInboxRailTab(
  tab: { id?: string; type?: string } | null | undefined,
): boolean {
  if (!tab) return false
  const id = String(tab.id ?? '')
  const type = String(tab.type ?? '')
  return id === 'inbox' || id.startsWith('inbox-thread-') || type === 'inbox' || type === 'inbox-thread'
}

export function isChatsRailTab(
  tab: { id?: string; type?: string } | null | undefined,
): boolean {
  if (!tab) return false
  const id = String(tab.id ?? '')
  const type = String(tab.type ?? '')
  return id.startsWith('chat-conversation-') || type === 'chat-conversation' || type === 'chat'
}

export function suggestedExtensionRailId(args: {
  primaryMode: string | null
  activeTab: { id?: string; type?: string } | null | undefined
}): SuggestedRailId | null {
  if (isBasecampLimbTab(args.activeTab) && args.primaryMode !== 'basecamp') return 'basecamp'
  if (isInboxRailTab(args.activeTab) && args.primaryMode !== 'inbox') return 'inbox'
  if (isChatsRailTab(args.activeTab) && args.primaryMode !== 'chats') return 'chats'
  return null
}
